import scratchCard from './scratchcard-icon.webp';

export default {
  scratchCard,
};
